import { configureStore } from '@reduxjs/toolkit'
import root from "./Reducres/rootReducer"

export const store = configureStore({
  reducer: { root }
})